var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoWms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "xtv5p0n21a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15357",
    transform: "translate(472 1477)",
    style: {
      fill: "#ff1010",
      opacity: 0.43
    },
    d: "M0 0h120v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 675",
    transform: "translate(-472 -1477)",
    style: {
      clipPath: "url(#xtv5p0n21a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 673"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15362",
    transform: "translate(503.864 1572.138)",
    style: {
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h18.454v19.248H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 52",
    transform: "translate(508.549 1586.645)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h3.45"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15364",
    transform: "translate(522.319 1572.138)",
    style: {
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h18.454v19.248H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 53",
    transform: "translate(527.004 1586.645)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h3.45"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15366",
    transform: "translate(540.774 1572.138)",
    style: {
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h18.454v19.248H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 54",
    transform: "translate(545.459 1586.645)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h3.45"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15368",
    transform: "translate(522.319 1552.867)",
    style: {
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h18.454v19.248H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 55",
    transform: "translate(527.004 1567.374)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h3.45"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15369",
    transform: "translate(540.774 1552.867)",
    style: {
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h18.454v19.248H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 56",
    transform: "translate(545.459 1567.374)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#4cbbb8",
      fill: "none"
    },
    d: "M0 0h3.45"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59471",
    d: "M554.357 1471.687v-66.982H627.5v66.982",
    transform: "translate(-59.306 119.695)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 75",
    transform: "translate(495.052 1531.859)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h72.988"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 76",
    transform: "translate(495.052 1539.133)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h72.988"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD328\\uC2A4 59472",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.782 39.751 55.748 9.844 4.717 39.751.75 32.982 55.748.75l55 32.232z",
    style: {
      stroke: "none"
    },
    transform: "translate(476.25 1482.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.782 39.75 3.968-6.768L55.748.75.75 32.982l3.968 6.769L55.748 9.844l51.034 29.907m-.002 2a1.99 1.99 0 0 1-1.01-.275L55.749 12.162 5.728 41.476a2 2 0 0 1-2.736-.714l-3.968-6.769a2 2 0 0 1 .714-2.737L54.737-.975a2 2 0 0 1 2.022 0l55.002 32.231a2 2 0 0 1 .714 2.737l-3.968 6.769a2 2 0 0 1-1.727.989z",
    style: {
      fill: "#fff",
      stroke: "none"
    },
    transform: "translate(476.25 1482.25)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 674"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 77",
    transform: "translate(486 1520.5)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v71"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 78",
    transform: "translate(578 1520.5)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v71"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 79",
    transform: "translate(486.5 1591.5)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h91"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWms);
export default __webpack_public_path__ + "static/media/ico_wms.740d9dae4cfb17e02fcd3590b01815c3.svg";
export { ForwardRef as ReactComponent };